// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getAllDataCatalogsClient = createAsyncThunk('appUsers/getAllDataCatalogsClient', async id => {
  const response = await axios.get('https://apiv4dev2.opentlv.com/api/v3/client/catalogs/all',  { params: { id} })
  return response.data
})

export const getDataCatalogsClient = createAsyncThunk('appUsers/getDataCatalogsClient', async params => {
  const response = await axios.get('https://apiv4dev2.opentlv.com/api/v3/client/catalogs/data', {params})
  return {
    params,
    data: response.data.data,
    totalPages: response.data.total
  }
})

export const getUser = createAsyncThunk('appUsers/getUser', async id => {
  const response = await axios.get('https://apiv4dev2.opentlv.com/api/v3/users/user', { params: { id} })
  console.log(response.data)
  return response.data
})

export const addUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch, getState }) => {
  await axios.post('/apps/users/add-user', user)
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})

export const deleteUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/users/delete', { id })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})

export const addCatalog = createAsyncThunk('appUsers/addCatalog', async (catalog, { dispatch, getState }) => {
 // catalog.client_id = getState().sitesClient.params.id
  //console.log(getState().sitesClient)


  await axios.post('https://apiv4dev2.opentlv.com/api/v3/client/addcatalog', catalog)

  //await dispatch(getAllDataSitesClient(getState().sitesClient.params.id))
  await dispatch(getDataCatalogsClient(getState().catalogsClient.params))
  return site
})

export const deleteCatalog = createAsyncThunk('appUsers/deleteCatalog', async (id, { dispatch, getState }) => {


  await axios.delete('https://apiv4dev2.opentlv.com/api/v3/client/catalog/delete', {params: {id}})
//  await dispatch(getData(getState().users.params))
    await dispatch(getDataCatalogsClient(getState().catalogsClient.params))

  return id
})

export const appClientsSlice = createSlice({
  name: 'appUsers',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllDataCatalogsClient.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getDataCatalogsClient.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
  }
})

export default appClientsSlice.reducer
